import { API, graphqlOperation } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Loader } from "@aws-amplify/ui-react";

import ActivityForm from "components/activities/ActivityForm";
import { updateActivity } from "graphql/mutations";
import {
  getActivity,
} from "graphql/queries";

const ActivityUpdateForm = ({ activityId, onSuccess }) => {
  const navigate = useNavigate();
  const [activity, setActivity] = useState();

  async function onSubmit(valuesAct) {
    try {
      const {
        name,
        type,
        description,
        abbreviation,
        unit,
        defaultValue,
        values,
      } = valuesAct;

      await API.graphql({
        query: updateActivity.replaceAll("__typename", ""),
        variables: {
          input: {
            id: activityId,
            name,
            type,
            description,
            abbreviation,
            unit,
            defaultValue,
            values: JSON.stringify(values),
          },
        },
      });

      toast.success(strings.successUpdated);
      if (onSuccess) onSuccess();
      else navigate("/activities");
    } catch (err) {
      toast.error(strings.responses[err]);
    }
  }

  async function fetchActivity(id) {
    try {
      const activityData = await API.graphql(
        graphqlOperation(getActivity, { id })
      );
      const activityItem = activityData.data.getActivity;
      if (!activityItem) {
        toast.error(strings.responses.errorFetch);
        navigate("/activities");
        return;
      }
      setActivity({
        ...activityItem,
        values: JSON.parse(activityItem.values ?? "[]"),
      });
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    }
  }

  useEffect(() => {
    fetchActivity(activityId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activityId]);

  if (!activity) return <Loader />;

  return (
    <div>
      <ActivityForm
        onSubmit={onSubmit}
        type="update"
        initialValues={activity}
      />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Actualizar Actividad",
    successUpdated: "Actividad actualizada con éxito",
    responses: {
      errorFetch: "Error al consultar la actividad",
    },
  },
});

export default ActivityUpdateForm;
